// ** API Imports
import { API } from '../../../../../../utility/API'

//************************************//
export const _getBalances = (callback, callbackErr) => {
  API.get(`trading/account/balances`)
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (error) {
      callbackErr(error)
    })
}
//************************************//
export const _getStakingEstimateRewards = ({ amount = null, staking_period_id = null }, callback, callbackErr) => {
  API.post(`trading/account/staking/estimate_reward`, { amount, staking_period_id })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (error) {
      callbackErr(error)
    })
}
//************************************//
export const _createStakingSubscription = ({ amount = null, staking_period_id = null, staking_provider_id = 1 }, callback, callbackErr) => {
  API.post(`trading/account/staking/new`, { amount, staking_period_id, staking_provider_id })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (error) {
      console.error('Error creating staking subscription:', error)

      // Enhanced error handling
      let errorMessage = 'Failed to create staking subscription'
      let errorData = null

      if (error.response) {
        // Server responded with error status
        const { status, data } = error.response
        errorData = data

        switch (status) {
          case 400:
            errorMessage = data?.message || data?.error || 'Invalid request parameters'
            break
          case 401:
            errorMessage = 'Authentication required. Please log in again.'
            break
          case 403:
            errorMessage = 'Access denied. You don\'t have permission to perform this action.'
            break
          case 404:
            errorMessage = 'Staking product not found or no longer available'
            break
          case 409:
            errorMessage = data?.message || 'Conflict: You may already have an active subscription for this product'
            break
          case 422:
            errorMessage = data?.message || 'Validation failed. Please check your input.'
            break
          case 429:
            errorMessage = 'Too many requests. Please try again later.'
            break
          case 500:
            errorMessage = 'Server error. Please try again later.'
            break
          case 503:
            errorMessage = 'Service temporarily unavailable. Please try again later.'
            break
          default:
            errorMessage = data?.message || data?.error || `Server error (${status})`
        }

        // Handle specific error formats
        if (data?.errors && Array.isArray(data.errors) && data.errors.length > 0) {
          errorMessage = data.errors[0]
        } else if (data?.validation_errors) {
          const validationErrors = Object.values(data.validation_errors).flat()
          errorMessage = validationErrors[0] || errorMessage
        }
      } else if (error.request) {
        // Network error
        errorMessage = 'Network error. Please check your connection and try again.'
      } else {
        // Other error
        errorMessage = error.message || 'An unexpected error occurred'
      }

      callbackErr({
        ...error.response,
        message: errorMessage,
        originalError: error,
        errorData
      })
    })
}
//************************************//
export const _getStakingPeriods = ({ currency_id, product_name, currency_name }, callback, callbackErr) => {
  API.get(`trading/earn/staking_periods`, { params: { search: { currency_id, product_name, currency_name } } })
    .then(function ({ data }) {
      callback(data)
    })
    .catch(function (error) {
      callbackErr(error)
    })
}
//************************************//
